(() => {
  const popup = document.querySelector('[data-tului-popup]');
  if (!popup) return;

  const popupForm = document.getElementById('TuluiPopupForm');
  const popupEmail = document.getElementById('TuluiPopupEmail');
  const popupError = document.getElementById('TuluiPopupError');
  const popupSuccess = popup.querySelector('[data-tului-popup-success]');
  const waitlistSuccess = document.querySelector('[data-tului-waitlist-success]');
  const closeButton = popup.querySelector('[data-tului-popup-close]');
  const storageSeenKey = 'tului_popup_seen';
  const storageJoinedKey = 'tului_popup_joined';
  const storageSourceKey = 'tului_capture_source';
  const fourteenDays = 14 * 24 * 60 * 60 * 1000;
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  let previousFocus = null;
  let closeTimer = null;
  let blurTimer = null;
  let triggerPending = false;
  let isOpen = false;

  const storageGet = (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  };

  const storageSet = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (_error) {
      return;
    }
  };

  const sessionGet = (key) => {
    try {
      return window.sessionStorage.getItem(key);
    } catch (_error) {
      return null;
    }
  };

  const sessionRemove = (key) => {
    try {
      window.sessionStorage.removeItem(key);
    } catch (_error) {
      return;
    }
  };

  const isSuppressed = () => {
    if (storageGet(storageJoinedKey)) return true;

    const seenAt = Number(storageGet(storageSeenKey));
    return Number.isFinite(seenAt) && Date.now() - seenAt < fourteenDays;
  };

  const isMobileFormFocused = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return false;
    const active = document.activeElement;
    return Boolean(active?.matches('input, select, textarea, [contenteditable="true"]'));
  };

  const focusableElements = () =>
    Array.from(popup.querySelectorAll(focusableSelector)).filter(
      (element) => !element.hasAttribute('hidden') && element.getClientRects().length > 0,
    );

  const openPopup = ({ remember = true } = {}) => {
    if (isOpen) return;
    window.clearTimeout(closeTimer);
    previousFocus = document.activeElement;
    isOpen = true;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tului-popup-open');
    if (remember) storageSet(storageSeenKey, String(Date.now()));

    window.requestAnimationFrame(() => {
      popup.classList.add('is-open');
      const firstTarget = popupEmail || closeButton || popup.querySelector('.tului-popup__plate');
      firstTarget?.focus({ preventScroll: true });
    });
  };


  const chipDismissKey = 'tului_chip_dismissed';
  const chipWindowMs = 14 * 24 * 60 * 60 * 1000;
  let chipShown = false;
  let chipEl = null;

  const chipSuppressed = () => {
    if (storageGet(storageJoinedKey)) return true;
    const dismissed = Number(storageGet(chipDismissKey) || 0);
    return dismissed && Date.now() - dismissed < chipWindowMs;
  };

  const hideChip = () => {
    if (!chipEl) return;
    chipEl.classList.remove('is-open');
    const el = chipEl;
    window.setTimeout(() => el.remove(), 220);
    chipEl = null;
  };

  const showChip = () => {
    if (chipSuppressed() || chipEl) return;
    chipEl = document.createElement('div');
    chipEl.className = 'tului-chip';
    chipEl.setAttribute('role', 'complementary');
    chipEl.setAttribute('aria-live', 'polite');
    chipEl.innerHTML =
      '<button type="button" class="tului-chip__close" aria-label="Dismiss">&times;</button>' +
      '<span class="tului-chip__tick" aria-hidden="true"></span>' +
      '<p class="tului-chip__title">THE FIRST 5,000</p>' +
      '<p class="tului-chip__line">Your 10% founding code is waiting.</p>' +
      '<button type="button" class="tului-chip__cta">LOCK MY CODE</button>';
    document.body.appendChild(chipEl);
    chipEl.querySelector('.tului-chip__close').addEventListener('click', () => {
      storageSet(chipDismissKey, String(Date.now()));
      hideChip();
    });
    chipEl.querySelector('.tului-chip__cta').addEventListener('click', () => {
      hideChip();
      openPopup({ remember: false });
    });
    chipEl.addEventListener('click', (event) => {
      if (event.target.closest('.tului-chip__close, .tului-chip__cta')) return;
      hideChip();
      openPopup({ remember: false });
    });
    window.requestAnimationFrame(() => chipEl && chipEl.classList.add('is-open'));
  };

  const scheduleChip = () => {
    if (chipShown || chipSuppressed()) return;
    chipShown = true;
    window.setTimeout(showChip, 20000);
  };

  const closePopup = () => {
    if (!isOpen) return;
    isOpen = false;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tului-popup-open');
    scheduleChip();

    closeTimer = window.setTimeout(() => {
      popup.hidden = true;
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180);
  };

  const tryOpen = () => {
    if (isOpen || isSuppressed()) return;
    if (isMobileFormFocused()) {
      triggerPending = true;
      return;
    }
    triggerPending = false;
    openPopup();
  };

  const handleScroll = () => {
    const scrollableDistance = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollableDistance <= 0 || window.scrollY / scrollableDistance < 0.4) return;
    window.removeEventListener('scroll', handleScroll);
    tryOpen();
  };

  const pendingSource = sessionGet(storageSourceKey);
  if (popupSuccess || waitlistSuccess) {
    storageSet(storageJoinedKey, 'true');
    sessionRemove(storageSourceKey);
  }

  if (popupSuccess && pendingSource !== 'waitlist') {
    openPopup({ remember: false });
  } else if (!isSuppressed()) {
    window.setTimeout(tryOpen, 8000);
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  closeButton?.addEventListener('click', closePopup);
  popup.addEventListener('click', (event) => {
    if (event.target.closest('[data-tului-popup-dismiss]')) closePopup();
  });

  document.addEventListener('focusout', () => {
    if (!triggerPending) return;
    window.clearTimeout(blurTimer);
    blurTimer = window.setTimeout(tryOpen, 2000);
  });

  document.addEventListener('keydown', (event) => {
    if (!isOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup();
      return;
    }

    if (event.key !== 'Tab') return;
    const elements = focusableElements();
    if (!elements.length) {
      event.preventDefault();
      return;
    }

    const first = elements[0];
    const last = elements[elements.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (popupForm && popupEmail && popupError) {
    popupForm.addEventListener('submit', (event) => {
      try { var _e=popupForm.querySelector('input[type=email]'); if (window.tuluiTrackLead) window.tuluiTrackLead('popup', _e && _e.value); } catch (err) {}
      popupError.textContent = '';
      popupEmail.removeAttribute('aria-invalid');

      if (!popupEmail.validity.valid) {
        event.preventDefault();
        popupEmail.setAttribute('aria-invalid', 'true');
        popupError.textContent = 'Enter a valid email address and try again.';
        popupEmail.focus();
      }
    });
  }
})();
